import React from "react";
import LegalTextPage from "../legal/LegalTextPage";
import { addTC, getTC } from "../../../services/settings";

const Terms = () => (
  <LegalTextPage
    load={getTC}
    field="terms"
    save={addTC}
    texts={{
      title: "Terms and Conditions",
      empty: "Please Enter Terms and Conditions First",
      saved: "T & C Added Successfully !",
      failed: "Adding T & C Failed!",
    }}
  />
);

export default Terms;
